<template>
  <div
    class="AvailableDatasetsList">
    <div
      class="AvailableDatasetsListItem"
      v-for="dataset in previewDatasets"
      :key="dataset.name">
      <i
        class="AvailableDatasetsListItem_icon icon-domo-database">
      </i>
      {{ dataset.name }}
    </div>

    <BaseButton
      v-if="availableDatasets.length > 3"
      key="ADL-see-all"
      class="mt-1 color-dark-blue"
      size="small"
      theme="ghost"
      @click="handleSeeDatasetsClick($route)">
      SEE ALL {{ availableDatasets.length }} DATASETS
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'AvailableDatasetsList',

  components: {
    BaseButton,
  },

  props: {
    availableDatasets: { type: Array, required: true },
  },

  computed: {
    previewDatasets() {
      return this.availableDatasets.slice(0, 3);
    },
  },

  methods: {
    handleSeeDatasetsClick(route) {
      this.$emit('see-datasets-click');

      if (route.params.tab === 'datasets') return;

      this.$router.replace({
        name: 'app-detail',
        params: {
          appType: route.params.appType || 'app',
          appName: route.params.appName || 'null',
          tab: 'datasets',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.AvailableDatasetsListItem {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba($black, .6);
}

.AvailableDatasetsListItem + .AvailableDatasetsListItem {
  margin-top: 4px;
}

.AvailableDatasetsListItem_icon {
  display: inline-block;
  height: 24px;
  font-size: 24px;
  line-height: 14px;
  vertical-align: middle;
}
</style>
